export interface INDRAPaymentMethod {
	status: string;
	errors: [];
	timeService: null;
	timeBackend: null;
	data: {
		iteamsAdyenBean: INDRAItemsAdyenBean[],
		storedAdyen: INDRAStoredPaymentCredentials,
		fops: INDRAPaymentMethodFops[],
		payment: INDRAPaymentMethodFees,
		storedOCPPaypal?: boolean,
		cardOcpEnable?: boolean,
		paybyrdEnabled?: boolean,
		adyenPopUpEnabled?: boolean,
		paybyrdHppRedFlag?: boolean,
		tokenCardLess: string,
	};
	paymentSessionID: string;
}

export interface INDRAPaymentMethodFops {
	gatewayMethodFopId: number;
	fopName: string;
	fopCode: string;
	gatewayName: string;
	gatewayCode: string;
	paymentMethodName: string;
	paymentMethodCode: string;
	params: INDRAPaymentMethodParams[];
	fee: INDRAFOPFee;
	maxAttemptsToPay: string;
	enable: boolean;
}

export interface INDRAItemsAdyenBean {
	id: string;
	name: string;
}

export interface INDRAPaymentMethodFees {
	basePrice: number;
	fee: number;
	feeAmount: number;
	price: number;
}

export interface INDRAPaymentMethodParams {
	paramCode: string;
	paramValue: string;
}

export interface INDRAFOPFee {
	amount: number;
	isPercent; boolean;
}

export class CreditCard {
	code: string;
	brand: string;
	image: string;
	name: string;
	regex: string;
	merchantAccount: string;
	variant: string;
	fee: INDRAFOPFee;

	constructor(code: string, brand: string, image: string, name: string, regex: string, merchantAccount: string, variant: string, fee: INDRAFOPFee) {
		this.code = code;
		this.name = name;
		this.brand = brand;
		this.image = image;
		this.regex = regex;
		this.merchantAccount = merchantAccount;
		this.variant = variant;
		this.fee = fee;
	}
}

export class CardBrand {
	code: string;
	brand: string;
	image: string;
	name: string;
	regex: string;
	merchantAccount: string;


	constructor(code: string, brand: string, image: string, name: string, regex: string, merchantAccount: string) {
		this.code = code;
		this.name = name;
		this.brand = brand;
		this.image = image;
		this.regex = regex;
		this.merchantAccount = merchantAccount;
	}
}

export class DataUserPayment {
	addressLine: string;
	cityName: string;
	code: string;
	countryCode: string;
	countryValue: string;
	stateCode?: string;
	stateValue?: string;
	cvc: string;
	expiryMonth: string;
	expiryYear: string;
	givenName: string;
	holderName: string;
	ipAddress: string;
	isCCHolderTravel: string;
	number: string;
	phoneNumber: string;
	postalCode: string;
	surname: string;
	merchantAccount: string;
	moment: number;
	cpf?: string;
	numberInstallments?: string;
	amountInstallments?: string;
}


export interface INDRAStoredPaymentCredentials {
	creationDate: string;
	details: INDRAStoredPaymentCredentialDetails[];
	errorCode: string;
	errorType: string;
	message: string;
	shopperReference: string;
	status: string;
}

export interface INDRAStoredPaymentCredentialDetails {
	RecurringDetail: INDRAPaymentCredsRecurringDetail;
}

export interface INDRAPaymentCredsRecurringDetail {
	additionalData: INDRAPaymentCredsAdditionalData;
	alias: string;
	aliasType: string;
	card: INDRAPaymentCardDetail;
	creationDate: string;
	firstPspReference: string;
	name: string;
	paymentMethodVariant: string;
	recurringDetailReference: string;
	variant: string;
}

export interface INDRAPaymentCredsAdditionalData {
	cardBin: string;
}

export interface INDRAPaymentCardDetail {
	expiryMonth: string;
	expiryYear: string;
	holderName: string;
	number: string;
}

export interface INDRARedeemVoucherDetail {
	status: string;
	errors: [];
	timeService: null;
	timeBackend: null;
	data: {
		vouchers: [{
			identifier: string,
			status: string
		}]
	}
}